import { useEffect, useState } from 'react';

import { useRemoveQueryParams } from '@sureapp/wl-toggle-common/dist/hooks/useRemoveQueryParams';

import { useAppDispatch, useAppSelector } from '@@/auto/hooks/redux';
import { IFeatureFlag } from '@@/auto/interfaces';
import { getFeatureFlags } from '@@/auto/store/actions';

function toFeatureFlag(flag: string): IFeatureFlag {
  const [code, status] = flag.split('=');
  return { code, status: status.toLowerCase() === 'true' };
}

function parseFeatureFlagQueryParamsToArray(param: string): IFeatureFlag[] {
  return decodeURIComponent(param ?? '')
    ?.split(',')
    .filter(Boolean)
    .map(toFeatureFlag);
}

export function useFetchFeatureFlags() {
  const dispatch = useAppDispatch();
  const { featureFlags } = useAppSelector((store) => store);
  const removeQueryParams = useRemoveQueryParams();
  const [isLoadingFeatureFlags, setIsLoadingFeatureFlags] = useState(false);

  useEffect(
    function loadFeatureFlags() {
      async function fetchFlags() {
        if (featureFlags.length > 0) {
          return;
        }
        setIsLoadingFeatureFlags(true);

        const { feature_flags: flags } = removeQueryParams(['feature_flags']);
        const overrides = flags
          ? parseFeatureFlagQueryParamsToArray(flags)
          : [];

        try {
          await getFeatureFlags(overrides)(dispatch);
        } catch {
          /* fallback to feature flag defaults */
        }
        setIsLoadingFeatureFlags(false);
      }

      fetchFlags();
    },
    [removeQueryParams, dispatch, featureFlags.length]
  );

  return { isLoadingFeatureFlags };
}
